import React, { useEffect, useState } from 'react';
import { useParams, Link, Navigate } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { disorders, findDisorder } from '../data/disorders';
import '../styles/articles.css';

const ArticleDetail = () => {
  const { slug } = useParams();
  const disorder = findDisorder(slug);
  const [activeId, setActiveId] = useState(null);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'auto' });
  }, [slug]);

  useEffect(() => {
    if (!disorder) return;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) setActiveId(entry.target.id);
        });
      },
      { rootMargin: '-30% 0px -60% 0px', threshold: 0 }
    );
    const els = document.querySelectorAll('[data-spy]');
    els.forEach((el) => observer.observe(el));
    return () => els.forEach((el) => observer.unobserve(el));
  }, [disorder]);

  if (!disorder) {
    return <Navigate to="/resources/articles" replace />;
  }

  const sections = disorder.sections || [];
  const currentIndex = disorders.findIndex((d) => d.slug === slug);
  const prev = currentIndex > 0 ? disorders[currentIndex - 1] : null;
  const next = currentIndex < disorders.length - 1 ? disorders[currentIndex + 1] : null;

  return (
    <>
      <Navbar />
      <div className="articles-page">
        <div className="container">

          <nav className="article-breadcrumb">
            <Link to="/resources/articles">Articles &amp; guides</Link>
            <span aria-hidden="true">/</span>
            <span>{disorder.title}</span>
          </nav>

          <div className="article-detail-header">
            <span className="section-tag">{disorder.fullName}</span>
            <h1>{disorder.title}</h1>
            <p>{disorder.summary}</p>
          </div>

          <div className="articles-layout">

            <aside className="articles-toc">
              <div className="toc-sticky">
                <span className="toc-label">On this page</span>
                <nav className="toc-nav">
                  <ul className="toc-flat">
                    {sections.map((s) => (
                      <li key={s.id}>
                        <a
                          href={`#${s.id}`}
                          className={activeId === s.id ? 'active' : ''}
                        >
                          {s.title}
                        </a>
                      </li>
                    ))}
                  </ul>
                </nav>
              </div>
            </aside>

            <main className="articles-content">
              <section className="disorder-block">
                {sections.map((s) => (
                  <section
                    key={s.id}
                    id={s.id}
                    data-spy
                    className="disorder-section"
                  >
                    <h3>{s.title}</h3>
                    <div className="section-body">{s.content}</div>
                  </section>
                ))}
              </section>

              <div className="article-pager">
                {prev ? (
                  <Link to={`/resources/articles/${prev.slug}`} className="article-pager-link prev">
                    <span className="pager-label">Previous</span>
                    <span className="pager-title">{prev.title}</span>
                  </Link>
                ) : <span />}
                {next ? (
                  <Link to={`/resources/articles/${next.slug}`} className="article-pager-link next">
                    <span className="pager-label">Next</span>
                    <span className="pager-title">{next.title}</span>
                  </Link>
                ) : <span />}
              </div>

              <div className="articles-disclaimer">
                <p>
                  <strong>Educational use only.</strong> Information on this page is intended
                  for general awareness and does not replace a professional clinical evaluation.
                  If you or someone you know is struggling, please consider speaking with a
                  qualified mental health professional.
                </p>
              </div>
            </main>

          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default ArticleDetail;
